<header>
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
        <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container h-100">
        <div class="align-items-center">
            <div>
                <div class="global-container">
                    <div class="card forgot-pwd-form">
                        <div class="card-body">
                            <div class="card-text">
                                <h4 class="headerStyles">Forgot Password</h4>
                                <div class="row">
                                    <div class="col-md-12">
                                        <form [formGroup]="forgotpwdForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-12  m-0">
                                                    <input type="text" class="form-control" maxlength="100" formControlName="emailId" placeholder="Email Id" autocomplete="new-password" [ngClass]="{ 'is-invalid':  submitted && f.emailId.errors }">

                                                    <div *ngIf=" submitted && f.emailId.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.emailId.errors.required">EmailId {{errorMsgs.required}}</div>
                                                        <div *ngIf=" submitted && f.emailId.errors.email">{{errorMsgs.email}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <label oncopy="return false" oncut="return false" onpaste="return false" onselectstart="return false" class="capchImage">{{captchImage}}
                                                        <span (click)="generateCaptcha()" style="padding: 0 15px;"><i class="fas fa-sync-alt"></i></span>
                                                    </label>
                                                    <input type="text" class="form-control" placeholder="Enter Captcha" formControlName="captch" [ngClass]="{ 'is-invalid':  submitted && f.captch.errors }">
                                                    <div *ngIf=" submitted && f.captch.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.captch.errors.required">Captcha {{errorMsgs.required}}</div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="row">
                                                <!-- <div class="col-md-6">
                                                    <img src="{{filePath}}{{captchImage}}" alt="Captcha" />
                                                </div> -->
                                                <!-- <div class="form-group col-md-12"> 
                                                    <label oncopy="return false" oncut="return false" onpaste="return false" onselectstart="return false" class="form-control capchImage">{{captchaImage}}
                                                        <span (click)="getCaptchaValue()" style="padding: 0 15px;"><i class="fas fa-sync-alt"></i></span>
                                                    </label>
                                                </div> -->
                                                <div class="wrapper">
                                                 
                                                    <div class="captcha-area">
                                                      <div class="captcha-img">
                                                        <img src='/assets/captcha-bg.png' alt="Captch Background"/>
                                                        <span class="captcha">{{captchaImage}}</span>
                                                      </div>
                                                      &nbsp; <button class="reload-btn" (click)="getCaptchaValue()"><i class="fas fa-redo-alt" (click)="getCaptchaValue()"></i></button>
                                                    </div>
                                                    </div>
                                            </div>

                                            <div class="row">
                                                <div class="form-group col-md-12">
                                                    <input type="text" class="form-control" placeholder="Enter Captcha" formControlName="captcha" 
                                                    [ngClass]="{ 'is-invalid':  submitted && f.captcha.errors }" maxlength="5" autocomplete="new-password">
                                                    <div *ngIf=" submitted && f.captcha.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.captcha.errors.required">Captcha {{errorMsgs.required}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" formControlName="recaptcha">
    `                                                 </ngx-recaptcha2>
                                                </div>
                                             </div> -->
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <button class="form-control btn btn-primary" type="button" [disabled]="!forgotpwdForm.valid" (click)="getRandomKeyGenerator()">Submit</button>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12" style="padding-top: 5px;text-align: center;font-size: 15px;">
                                                    <p>
                                                        <a routerLink="../login" *ngIf="!moduleStdReg">Login</a>
                                                        <a routerLink="../../login/student" *ngIf="moduleStdReg">Login</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>